// Generated with util/create-component.js
import React from 'react'
import merge from 'lodash/merge'
import { RowProps } from './Row.types'

const Row: React.FC<RowProps> = ({
    children,
    noPadding,
    maxWidth,
    fullHeight,
    middleContent,
    width,
    flexGrow,
    center,
    background,
    style,
    column,
    noWrap,
    alignEnd,
    className = '',
}) => {
    const classNames = ['r-row', className]

    if (noPadding) {
        classNames.push('no-padding')
    }

    const _style: React.CSSProperties = {
        width: width || '100%',
        height: fullHeight ? '100%' : '',
        maxWidth: maxWidth || 'auto',
        background: background || 'none',
        margin: center ? '0 auto' : '',
        padding: noPadding ? 0 : '',
        flexDirection: column ? 'column' : 'row',
        flexGrow: flexGrow ? 1 : 0,
        flexWrap: noWrap ? 'nowrap' : 'wrap',
        alignItems: middleContent ? 'center' : '',
        // border: '1px solid gray'
    }

    if (alignEnd) {
        _style.alignItems = 'flex-end'
    }

    return (
        <div data-testid='Row' style={merge(_style, style)} className={classNames.join(' ')}>
            {children}
        </div>
    )
}

export default Row
